import { useState } from "react";
import DirectionalButton from "./DirectionalButton";

function QueryModal() {
  const [submitted, setSubmitted] = useState(false);

  function validateEmail(input) {
    const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(input.value.trim());
    input.setCustomValidity(isValid ? "" : "Please enter a valid email address.");
  }

  function validatePhone(input) {
    const value = input.value.trim();
    const digits = value.replace(/\D/g, "");
    const usesValidCharacters = /^\+?[0-9\s()-]+$/.test(value);
    const isValid = usesValidCharacters && digits.length >= 10 && digits.length <= 15;
    input.setCustomValidity(isValid ? "" : "Please enter a valid 10–15 digit phone number.");
  }

  function handleSubmit(event) {
    event.preventDefault();
    validateEmail(event.currentTarget.elements.email);
    validatePhone(event.currentTarget.elements.phone);
    if (!event.currentTarget.checkValidity()) {
      event.currentTarget.classList.add("was-validated");
      return;
    }

    setSubmitted(true);
    event.currentTarget.reset();
    event.currentTarget.classList.remove("was-validated");
  }

  function resetModal() {
    setSubmitted(false);
  }

  return (
    <div
      className="modal fade query-modal"
      id="queryModal"
      tabIndex="-1"
      aria-labelledby="queryModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered query-modal-dialog">
        <div className="modal-content">
          <button
            type="button"
            className="query-modal-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={resetModal}
          >
            <i className="fa-solid fa-xmark" aria-hidden="true" />
          </button>

          <div className="query-modal-layout">
            <aside className="query-modal-visual" aria-hidden="true">
              <img src="/assets/images/project-1.webp" alt="" />
              <div className="query-modal-visual-copy">
                <span>Moonline Studio</span>
                <p>Thoughtful interiors, designed around the way you live.</p>
              </div>
            </aside>

            <div className="modal-body">
            <div className="query-modal-intro">
              <p className="eybrow query-modal-eyebrow">
                <img
                  className="star-icon"
                  src="/assets/images/star.png"
                  alt=""
                  aria-hidden="true"
                />
                Start a conversation
              </p>
              <h2 className="heading" id="queryModalLabel">Tell us about your space.</h2>
              <p>
                Share a few details and our design team will get in touch with
                you.
              </p>
            </div>

            {submitted ? (
              <div className="query-success" role="status">
                <span aria-hidden="true">
                  <i className="fa-solid fa-check" />
                </span>
                <h3>Thank you for your query.</h3>
                <p>Our team will connect with you shortly.</p>
                <DirectionalButton
                  as="button"
                  type="button"
                  data-bs-dismiss="modal"
                  onClick={resetModal}
                >
                  Close
                </DirectionalButton>
              </div>
            ) : (
              <form className="query-form needs-validation" noValidate onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-md-6">
                    <label htmlFor="queryName" className="form-label">Name</label>
                    <input id="queryName" name="name" className="form-control" type="text" autoComplete="name" required />
                    <div className="invalid-feedback">Please enter your name.</div>
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="queryEmail" className="form-label">Email</label>
                    <input
                      id="queryEmail"
                      name="email"
                      className="form-control"
                      type="email"
                      autoComplete="email"
                      inputMode="email"
                      onInput={(event) => validateEmail(event.currentTarget)}
                      onBlur={(event) => validateEmail(event.currentTarget)}
                      required
                    />
                    <div className="invalid-feedback">Please enter a valid email.</div>
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="queryPhone" className="form-label">Phone</label>
                    <input
                      id="queryPhone"
                      name="phone"
                      className="form-control"
                      type="tel"
                      autoComplete="tel"
                      inputMode="tel"
                      placeholder="+91 98765 43210"
                      maxLength="20"
                      onInput={(event) => validatePhone(event.currentTarget)}
                      onBlur={(event) => validatePhone(event.currentTarget)}
                      required
                    />
                    <div className="invalid-feedback">Please enter a valid 10–15 digit phone number.</div>
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="queryLocation" className="form-label">Location</label>
                    <input id="queryLocation" name="location" className="form-control" type="text" autoComplete="address-level2" required />
                    <div className="invalid-feedback">Please enter your location.</div>
                  </div>
                  <div className="col-12">
                    <label htmlFor="queryBudget" className="form-label">Budget</label>
                    <select id="queryBudget" name="budget" className="form-select" defaultValue="" required>
                      <option value="" disabled>Select your approximate budget</option>
                      <option value="under-25">Under ₹25 Lakhs</option>
                      <option value="25-50">₹25–50 Lakhs</option>
                      <option value="50-100">₹50 Lakhs–₹1 Crore</option>
                      <option value="above-100">Above ₹1 Crore</option>
                    </select>
                    <div className="invalid-feedback">Please select a budget.</div>
                  </div>
                  <div className="col-12">
                    <label htmlFor="queryComments" className="form-label">Comments</label>
                    <textarea id="queryComments" name="comments" className="form-control" rows="4" placeholder="Tell us about your project, timeline, and requirements" />
                  </div>
                  <div className="col-12">
                    <DirectionalButton as="button" type="submit">
                      Send Query <i className="fa-solid fa-arrow-right" aria-hidden="true" />
                    </DirectionalButton>
                  </div>
                </div>
              </form>
            )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default QueryModal;
